import { roadA2 } from "../../utils/ROADS/roadA2";
import RoadMapGeneric from "../../components/Roadmaps/RoadMapGeneric";

const RoadMapA2 = (props) => <RoadMapGeneric {...props} roadData={roadA2} />;

export default RoadMapA2;